window.Gift ?= {}

Gift.init = (payload, done) ->
  $ ->
    Gift.bindGiftButton()
    done()

Gift.bindGiftButton = ->
  $gift_button  = $('.gift-button')

  if $gift_button.length > 0
    $gift_button.on('click', (e) ->
      e.preventDefault()
      Gift.createCookie()

      BuyButton.view.giftButtonClicked = true
      BuyButton.eventBus.go 'buy_button_clicked'
    )

Gift.createCookie = ->
  cookieDomain = payload?.giftButton?.cookieDomain
  Cookie.set('modalForGiftOnLoad','true',60, cookieDomain)
  Gift.cookieCreated = true

Gift.removeCookie = ->
  cookieDomain = payload?.giftButton?.cookieDomain
  Cookie.unset('modalForGiftOnLoad', cookieDomain)
  Gift.cookieCreated = false


module.exports = Gift
